// Capgo over-the-air (OTA) updates.
//
// With autoUpdate enabled (capacitor.config.json), the Capgo plugin checks for a newer web
// bundle on launch, downloads it in the background, and applies it on the next start. After
// an update is applied, the app MUST call notifyAppReady() early on boot to confirm the new
// bundle loaded successfully - otherwise Capgo auto-rolls-back to the previous bundle (a
// safety net against shipping a broken bundle). So this runs on every native launch.
//
// No-op on the web (isNativePlatform() is false); best-effort and never throws into the UI.

import { CapacitorUpdater } from "@capgo/capacitor-updater";

import { isNativePlatform } from "./platform";

export async function notifyOtaAppReady() {
  if (!isNativePlatform()) return;
  try {
    await CapacitorUpdater.notifyAppReady();
  } catch (e) {
    console.warn("[ota] notifyAppReady failed", e);
  }
}
